<template>
    <div class="list-assignment" :class="[scrollbarClass, { 'no-scroll': !expandedSectionNav }]">
        <div class="item" v-for="user in localUserAffected">
            <div class="picture">
                <img :src="user.avatar ? user.avatar : 'img/avatar.jpg'"/>
            </div>
            <div class="info-text">
                <div class="container-name">
                    <p class="name">{{ user.firstname }} {{ user.lastname }}</p>
                    <p class="role">{{ user.admin == true ? $t('dash.select-users.admin') : user.role && user.role.length > 0 ? $t(`dash.settings.user.${user.role[0]}`) : $t("dash.settings.user.Editor") }}</p>
                </div>
                <p class="email">{{ user.email }}</p>
            </div>

            <template v-if="!isViewer">
                <div class="remove" @click="removeUserAffected(user.id)">
                    <i class="fa-solid fa-xmark-large"></i>
                </div>
            </template>
        </div>

        <template v-if="validationStatus !== null">
            <div v-if="validationStatus" class="btn-primary" @click="removeValidationPost(null)" :class="{loading: loadingValidation}">
                <p>{{ $t('dash.posts.drawer.cancel-validation') }}</p>
            </div>
            <div v-else class="btn-primary" @click="validatePost(null)" :class="{loading: loadingValidation}">
                <p>{{ $t('dash.posts.drawer.validate-post') }}</p>
            </div>
        </template>

        <template v-if="!isViewer">
            <div @click="setUsersAffected(null)" :class="{'btn-primary': validationStatus == null, 'btn-outline-primary': validationStatus !== null, loading: loadingAssign}">
                <p>{{ $t('dash.select-users.assign') }}</p>
            </div>
        </template>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import postMixin from '@/components/mixins/Posts.vue'
import postsMixin from '@/components/dash/posts/mixins/main.js'
import postCreatorMixin from '@/components/dash/postCreator/mixins/main.js'
import draftMixin from '@/components/mixins/Drafts.vue'
import CommonMixin from '@/components/mixins/Common'
import accessibilityMixin from '@/components/mixins/Accessibility.vue'

export default {
    mixins: [postMixin, postsMixin, postCreatorMixin, draftMixin, CommonMixin, accessibilityMixin],

    props: {
        currentUser: { type: Object, required: true },
        validationStatus: { default: null },
        expandedSectionNav: { type: Boolean, default: false },
        officialStatus: { type: String, required: true },
        event: { type: Object, required: true },
    },

    data() {
        return {
            loadingAssign: false,
            loadingValidation: false,
            localUserAffected: [],
            // requis par generateDataFormRequest (postCreatorMixin)
            tab: null,
            saveAllFormData: null,
            idUsersAssigned: [],
            requiredValidation: false,
            files: [],
            dataFormRequest: {},
            dataEditPost: {},
        }
    },

    created() {
        this.buildAssignment()
    },

    watch: {
        'event.originalPost'() {
            this.buildAssignment()
        },
    },

    computed: {
        isViewer() {
            return this.currentUser.role && this.currentUser.role.length === 1 && this.currentUser.role[0] === 'Viewer';
        },
        isNativeFacebookStory() {
            return this.event.page.network === 'facebook' && !this.event.originalPost?.page?.[0]?.shared_to_facebook
        },
    },

    methods: {
        buildAssignment() {
            this.localUserAffected = []
            if (this.event.originalPost.page.length && this.event.originalPost.page[0].affectedTo) {
                if (this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.length) {
                    this.localUserAffected = this.event.originalPost.page[0].affectedTo.users
                } else if (this.event.originalPost.page[0].affectedTo.user) {
                    this.localUserAffected = [this.event.originalPost.page[0].affectedTo.user]
                }
            }
            this.localUserAffected = this.localUserAffected.map(user => ({
                ...user,
                ...(this.$store.getters['users/getUsers'][user.id] || {}),
            }))
        },

        // Met à jour l'event local après une assignation, pour qu'une conversion lancée dans la
        // foulée (convertDraftToScheduledPost) reparte avec des données à jour.
        applyAssignmentLocally(draft, idUsersSelected, optionValidation) {
            this.$set(this.event, 'draft', draft)
            if (this.event.originalPost.page && this.event.originalPost.page[0]) {
                this.$set(this.event.originalPost.page[0], 'affectedTo', {
                    ...(this.event.originalPost.page[0].affectedTo || {}),
                    user: idUsersSelected.length ? this.$store.getters['users/getUsers'][idUsersSelected[0]] : null,
                    users: idUsersSelected.map(userId => this.$store.getters['users/getUsers'][userId]),
                    optionValidation,
                })
            }
        },

        async removeUserAffected(userId) {
            this.localUserAffected = this.localUserAffected.filter(user => user.id !== userId)
            const optionValidation = this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == true || this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == 'true'
            const idUsersSelected = this.localUserAffected.map(user => user.id)

            const draft = JSON.parse(JSON.stringify(this.event.draft))
            draft.idUsersAssigned = idUsersSelected
            draft.requiredValidation = optionValidation

            const data = {
                page: this.event.originalPost._bots[0].page.id,
                bot: this.event.originalPost._bots[0].id,
                post: this.event.originalPost.id,
                status: this.event.originalPost.status,
                optionValidation,
                draft,
            }

            if (idUsersSelected.length) {
                data.user = idUsersSelected[0]
                data.users = idUsersSelected
            }
            await this.affectedUserToPost(data)
            this.applyAssignmentLocally(draft, idUsersSelected, optionValidation)
            EventBus.$emit('planner/refresh', 1000)
        },

        async validatePost(all = null) {
            if (this.loadingValidation) return

            if (
                !(this.event.originalPost.page[0].affectedTo.user && this.event.originalPost.page[0].affectedTo.user.id == this.currentUser.id) &&
                !(this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
            ) {
                return
            }

            let countPage = 1
            if (this.officialStatus == "draft") countPage = this.event.draft.pages.length
            else if (this.event.originalPost.page[0] && this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length

            if (all == null) {
                if (countPage > 1) {
                    EventBus.$emit("showModal",
                        this.$t('dash.posts.multi-pages.validate_post.title'),
                        this.$t('dash.posts.multi-pages.validate_scheduled.body'),
                        this.$t('dash.posts.drawer.validate-all-posts'),
                        this.$t('dash.posts.drawer.validate-this-post'),
                        () => { this.validatePost(true) },
                        () => { this.validatePost(false) },
                    );
                    return
                } else {
                    all = false
                }
            }

            this.loadingValidation = true
            switch (this.officialStatus) {
                case "scheduled":
                // "processing" = déjà converti (assignation), traitement média encore en fond.
                case "processing":
                    await this.validateSchedulePost(all)
                    this.loadingValidation = false
                    break;
                case "draft":
                    setTimeout(() => {
                        EventBus.$emit("showModal",
                            this.$t(`dash.posts.multi-pages.validate_draft_to_post${countPage > 1 ? 's' : ''}.title`),
                            this.$t(`dash.posts.multi-pages.validate_draft_to_post${countPage > 1 ? 's' : ''}.body`),
                            this.$t('onboarding.2fa.continue'),
                            this.$t('dash.button.cancel'),
                            async () => {
                                await this.validateDraft(all)
                                this.loadingValidation = false
                            },
                            () => {
                                this.loadingValidation = false
                            }
                        )
                    }, 200);
                    break;
            }
        },

        async validateSchedulePost(all) {
            const res = await this.validateWaitingPost(this.event.originalPost, {
                name: `${this.currentUser.firstname} ${this.currentUser.lastname}`,
                email: this.currentUser.email,
                date: new Date().toISOString()
            }, all)

            this.$set(this.event, 'originalPost', { ...this.event.originalPost, ...res.body.post })
            const newEvent = await this.buildEvent({ ...this.event.originalPost, ...res.body.post })
            this.$set(this.event, 'status', newEvent.status)
            this.$set(this.event, 'originalStatus', newEvent.originalStatus)
            EventBus.$emit('planner/refresh', 2000)
        },

        async removeValidationPost(all = null) {
            if (this.loadingValidation) return

            let countPage = 1
            if (this.officialStatus == "draft") countPage = this.event.draft.pages.length
            else if (this.event.originalPost.page[0] && this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length

            if (all == null) {
                if (countPage > 1) {
                    EventBus.$emit("showModal",
                        this.$t('dash.posts.multi-pages.validate_post.title'),
                        this.$t('dash.posts.multi-pages.remove_validation.body'),
                        this.$t('dash.posts.multi-pages.remove_validation.btn-all'),
                        this.$t('dash.posts.multi-pages.remove_validation.btn-one'),
                        () => { this.removeValidationPost(true) },
                        () => { this.removeValidationPost(false) },
                    );
                    return
                } else {
                    all = false
                }
            }

            this.loadingValidation = true
            const res = await this.removeValidateWaitingPost(this.event.originalPost, all)
            this.$set(this.event, 'originalPost', { ...this.event.originalPost, ...res.body.post })
            this.loadingValidation = false
            const newEvent = await this.buildEvent({ ...this.event.originalPost, ...res.body.post })
            this.$set(this.event, 'status', newEvent.status)
            this.$set(this.event, 'originalStatus', newEvent.originalStatus)
            EventBus.$emit('planner/refresh', 2000)
        },

        // Brouillon Mongo/ES → post planifié via editAll. Appelé à l'assignation (chemin normal) et
        // depuis validateDraft (filet de sécurité). Pas de RequestManager : juste le loader du
        // bouton, le traitement continue en fond et remonte via planner/refresh.
        async convertDraftToScheduledPost(all, logTitle = 'dash.posts.log.scheduled-draft') {
            this.tab = this.event.draft.tab && this.event.draft.tab !== 'standard' ? 'story' : 'standard'
            this.saveAllFormData = this.event.draft.saveAllFormData
            this.idUsersAssigned = this.event.draft.idUsersAssigned
            this.requiredValidation = this.event.originalPost.page[0].affectedTo.optionValidation == true || this.event.originalPost.page[0].affectedTo.optionValidation == 'true'
            this.files = this.event.draft.files

            // Repousse à +1h une date de planification déjà passée (ex: "maintenant"), sinon la
            // conversion publierait immédiatement au lieu de planifier.
            const bumpIfPast = (planifiedDate) => {
                if (!planifiedDate || !planifiedDate.timestamp || planifiedDate.timestamp > Date.now()) return
                const d = new Date(Date.now() + 3600000)
                planifiedDate.date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
                planifiedDate.hours = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
                planifiedDate.timestamp = d.getTime()
            }
            bumpIfPast(this.saveAllFormData.main?.planifiedDate)
            Object.values(this.saveAllFormData.networks || {}).forEach(n => bumpIfPast(n?.planifiedDate))
            Object.values(this.saveAllFormData.pages || {}).forEach(p => bumpIfPast(p?.planifiedDate))

            let pagesSelected = [this.allPages[this.event.page.id]]

            if (all) {
                pagesSelected = this.event.draft.pages.reduce((acc, page) => {
                    if (this.allPages[page]) acc.push(this.allPages[page])
                    return acc
                }, [])
            }

            if (this.tab == 'story') {
                pagesSelected = pagesSelected.filter(page => page.network == 'instagram' || (page.network == 'facebook' && this.isNativeFacebookStory))
            }

            const dataFormRequest = await this.generateDataFormRequest(null, pagesSelected, false, false)

            if (Object.values(dataFormRequest).some(formData => formData.hasOwnProperty('error'))) {
                this.$vs.notify({
                    title: this.$t('dash.posts.drawer.validate-impossible'),
                    text: this.$t('dash.posts.drawer.validate-incomplete'),
                    color: 'success'
                })
                return
            }

            const multipages = this.event.originalPost.page[0].posts_multipages || []
            const posts = multipages.length > 0
                ? multipages.map(pm => ({
                    _id: pm._id,
                    id: pm._id,
                    bot: pm.bot,
                    page: pm.page,
                    postId: pm.postId || null,
                    status: pm.status,
                }))
                : [{
                    _id: this.event.originalPost.id,
                    id: this.event.originalPost.id,
                    bot: this.event.originalPost._bots[0].id,
                    page: this.event.originalPost._bots[0].page.id,
                    postId: this.event.originalPost.page[0].post_number,
                    status: this.event.originalPost.page[0].status,
                }]

            const log = this.generateLog({
                title: logTitle,
            })

            // L'historique réel vit sur page[0].log, pas dans le blob de formulaire draft.
            const existingLog = this.event.originalPost.page?.[0]?.log || []

            for (const [pageId, formData] of Object.entries(dataFormRequest)) {
                const post = posts.find(p => p.page == pageId)
                if (post) {
                    formData.postId = post.postId
                    formData.id = post._id
                }
                formData.log = JSON.stringify([JSON.stringify(log), ...existingLog])
            }

            const { draft, front_version } = Object.values(dataFormRequest).find(dfr => !dfr.hasOwnProperty('error')) || {}
            const response = await this.editAllPosts(dataFormRequest)
            this.addLog(this.currentUser, 'editAll-post', {
                payload: { ...dataFormRequest, draft, front_version },
                response
            })

            EventBus.$emit('planner/refresh', 500)

            // Rafraîchit l'event local (badge, bouton "retirer la validation") ; le drawer reste ouvert.
            const refreshed = await this.findPost(this.event.originalPost._bots[0].id, this.event.originalPost.id, null)
            if (refreshed?.body?.post) {
                const mergedPost = { ...this.event.originalPost, ...refreshed.body.post }
                this.$set(this.event, 'originalPost', mergedPost)
                const newEvent = await this.buildEvent(mergedPost)
                this.$set(this.event, 'status', newEvent.status)
                this.$set(this.event, 'originalStatus', newEvent.originalStatus)
            }
        },

        async validateDraft(all) {
            // Le flag isPgDraft renvoyé par le backend n'est pas fiable ici — on se base sur le
            // format de l'id, comme Posts2.vue:97 (ObjectId Mongo = 24 hex, uuid PG sinon).
            const isPgDraft = !/^[0-9a-f]{24}$/i.test(this.event.originalPost.id || '')

            // Filet de sécurité pour un brouillon Mongo/ES assigné avant ce changement.
            if (!isPgDraft) {
                await this.convertDraftToScheduledPost(all, 'dash.posts.log.validated-post')
                return
            }

            // Brouillon PG legacy : comportement inchangé, création d'un post par page via /posts/.
            this.tab = this.event.draft.tab && this.event.draft.tab !== 'standard' ? 'story' : 'standard'
            this.saveAllFormData = this.event.draft.saveAllFormData
            this.idUsersAssigned = this.event.draft.idUsersAssigned
            this.requiredValidation = this.event.originalPost.page[0].affectedTo.optionValidation == true || this.event.originalPost.page[0].affectedTo.optionValidation == 'true'
            this.files = this.event.draft.files

            let pagesSelected = [this.allPages[this.event.page.id]]

            if (all) {
                pagesSelected = this.event.draft.pages.reduce((acc, page) => {
                    if (this.allPages[page]) acc.push(this.allPages[page])
                    return acc
                }, [])
            }

            if (this.tab == 'story') {
                pagesSelected = pagesSelected.filter(page => page.network == 'instagram' || (page.network == 'facebook' && this.isNativeFacebookStory))
            }

            const dataFormRequest = await this.generateDataFormRequest(null, pagesSelected, false, false)

            if (Object.values(dataFormRequest).some(formData => formData.hasOwnProperty('error'))) {
                this.$vs.notify({
                    title: this.$t('dash.posts.drawer.validate-impossible'),
                    text: this.$t('dash.posts.drawer.validate-incomplete'),
                    color: 'success'
                })
                return
            }

            const log = this.generateLog({
                title: 'dash.posts.log.validated-post',
            })

            const requestGroup = []
            for (const [pageId, formData] of Object.entries(dataFormRequest)) {
                const page = this.allPages[pageId]
                formData.log = JSON.stringify([JSON.stringify(log), ...this.event.draft.log || []])
                requestGroup.push({
                    start: async (onSuccess, onProgress, onError) => {
                        try {
                            this.$store.commit('planner/addNewStaticEvent', {
                                eventId: this.event.originalPost.id + page.id,
                                event: {
                                    content: formData["data[title]"],
                                    date: formData["data[scheduled_date]"] || new Date().toISOString(),
                                    id: this.event.originalPost.id + page.id,
                                    image: formData["data[enclosure]"],
                                    page: page,
                                    loading: true,
                                    status: formData["data[scheduled_date]"] ? 'scheduled' : 'posted',
                                }
                            });

                            const response = await this.new({
                                ...formData,
                                "data[removeDraft]": this.event.originalPost.id,
                                "data[wait_validation]": JSON.stringify({
                                    name: `${this.currentUser.firstname} ${this.currentUser.lastname}`,
                                    email: this.currentUser.email,
                                    date: new Date().toISOString()
                                }),
                            });

                            this.$store.commit('planner/removeStaticEvent', this.event.originalPost.id + page.id)

                            if (response.data.success) {
                                EventBus.$emit('planner/refresh', 0)
                                this.$emit('close')
                                onSuccess(formData["data[scheduled_date]"] ? this.$t('dash.posts.drawer.post-scheduled') : this.$t('dash.posts.drawer.post-published'));
                                return { response, formData: { ...formData, pageId } }
                            } else {
                                throw new Error(this.$t('dash.posts.drawer.post-publish-failed'));
                            }
                        } catch (error) {
                            onError(error.message);
                            return { response: null, formData: { ...formData, pageId } }
                        }
                    },
                    params: {
                        picture: formData["data[enclosure]"] || page.avatar,
                        title: `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                        loadingText: !formData["data[scheduled_date]"] ? this.$t('dash.post-creator.request.publishing') : this.$t('dash.post-creator.request.scheduling')
                    }
                });
            }

            EventBus.$emit('requestManagerAddGroup', requestGroup, async (responses) => {
                try {
                    const posts = responses.filter(({ response }) => response.data.success && response.data.news && response.data.post && response.data.post.success).map(({ response, formData }) => ({
                        _id: response.data.news._id,
                        bot: formData.bot,
                        page: formData.pageId,
                        postId: response.data.post.post,
                        status: 1,
                        story: null,
                    }))
                    if (posts.length > 1) {
                        await this.updatePostsMultiPages(posts)
                    }
                    if (responses.length == posts.length) {
                        try {
                            this.deleteDraft(this.event.originalPost.id)
                        } catch (error) {
                            console.error("Echec de la supression du draft")
                        }
                    }
                } catch (error) {
                    console.error(error.message)
                }
            })
        },

        setUsersAffected(all = null) {
            if (this.loadingAssign) return

            let countPage = 1
            if (this.officialStatus == "draft") countPage = this.event.draft.pages.length
            else if (this.event.originalPost.page[0] && this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length

            if (all == null) {
                if (countPage > 1) {
                    EventBus.$emit("showModal",
                        this.$t('dash.posts.multi-pages.assign_users.title'),
                        this.$t('dash.posts.multi-pages.assign_users.body'),
                        this.$t('dash.posts.multi-pages.assign_users.btn-all'),
                        this.$t('dash.posts.multi-pages.assign_users.btn-one'),
                        () => { this.setUsersAffected(true) },
                        () => { this.setUsersAffected(false) },
                    );
                    return
                } else {
                    all = false
                }
            }

            this.loadingAssign = true

            const idPagesSelected = this.event.draft.pages
            const usersForSelector = Object.fromEntries(
                Object.entries(this.$store.getters['users/getUsers']).filter(([userId, user]) =>
                    (user.admin && (!user.pages_access || user.pages_access.length == 0))
                    || (user.pages_access && user.pages_access.length
                        && idPagesSelected.every(pageId => user.pages_access.includes(pageId)))
                )
            );

            const defaultSelection = this.localUserAffected.map(user => user.id)
            const optionValidation = this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == true || this.event.originalPost?.page?.[0]?.affectedTo?.optionValidation == 'true'

            EventBus.$emit('selectUsers', async (idUsersSelected, formCustom) => {
                const userChanged = defaultSelection.length != idUsersSelected.length || idUsersSelected.some(id => !defaultSelection.includes(id))
                const optionValidationChanged = optionValidation != (formCustom?.[0]?.name == "optionValidation" && formCustom[0].value == true)

                if (userChanged || optionValidationChanged) {
                    this.localUserAffected = idUsersSelected.map(userId => this.$store.getters['users/getUsers'][userId])

                    const draft = JSON.parse(JSON.stringify(this.event.draft))
                    draft.idUsersAssigned = idUsersSelected
                    draft.requiredValidation = formCustom?.[0]?.name == "optionValidation"

                    const data = {
                        page: this.event.originalPost._bots[0].page.id,
                        bot: this.event.originalPost._bots[0].id,
                        post: this.event.originalPost.id,
                        status: this.event.originalPost.status,
                        draft,
                        all,
                    }

                    if (formCustom && formCustom[0] && formCustom[0].name == "optionValidation") {
                        data.optionValidation = formCustom[0].value
                    }

                    if (idUsersSelected.length) {
                        data.user = idUsersSelected[0]
                        data.users = idUsersSelected
                    }

                    await this.affectedUserToPost(data)
                    this.applyAssignmentLocally(draft, idUsersSelected, data.optionValidation !== undefined ? data.optionValidation : optionValidation)

                    // Conversion en post planifié à l'assignation (Mongo/ES uniquement, PG legacy inchangé).
                    const isPgDraft = !/^[0-9a-f]{24}$/i.test(this.event.originalPost.id || '')
                    if (this.officialStatus === 'draft' && !isPgDraft && idUsersSelected.length) {
                        await this.convertDraftToScheduledPost(all)
                    }

                    EventBus.$emit('planner/refresh', 1000)
                }

                this.loadingAssign = false
            }, {
                users: usersForSelector,
                defaultSelection,
                subTitle: this.$t('dash.post-creator.assign.subtitle'),
                validButtonText: (idUsersAssigned) => {
                    if (idUsersAssigned.length == 0) return this.$t('dash.post-creator.assign.validate')
                    if (usersForSelector.length == 0 && idUsersAssigned.length > 0) return this.$t('dash.select-users.assign')
                    if (
                        idUsersAssigned.length === this.idUsersAssigned.length &&
                        [...idUsersAssigned].sort().join() === [...usersForSelector].sort().join()
                    ) return this.$t('dash.select-users.assign')
                    return this.$t('dash.post-creator.assign.update')
                },
                formCustom: [
                    {
                        type: 'checkbox',
                        name: 'optionValidation',
                        label: this.$t('dash.post-creator.assign.required-validation'),
                        value: optionValidation,
                        show: (idUsersAssigned) => idUsersAssigned.length > 0,
                    },
                ],
            }, () => {
                this.loadingAssign = false
            })
        },
    },
}
</script>
